import { render } from "./chatSupport.vue?vue&type=template&id=17c508ec&scoped=true"
import script from "./chatSupport.vue?vue&type=script&lang=js"
export * from "./chatSupport.vue?vue&type=script&lang=js"

import "./chatSupport.vue?vue&type=style&index=0&id=17c508ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c508ec"]])

export default __exports__